import React, { createContext, ReactNode, useState } from 'react';

type DataStorageProps = {
  isPageLoading: boolean;
  setIsPageLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const defaultContextValue = {
  isPageLoading: true,
  setIsPageLoading: () => {},
};

export const DataStorageContext =
  createContext<DataStorageProps>(defaultContextValue);

const DataStorageProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isPageLoading, setIsPageLoading] = useState(true);

  return (
    <DataStorageContext.Provider value={{ isPageLoading, setIsPageLoading }}>
      {children}
    </DataStorageContext.Provider>
  );
};

export default DataStorageProvider;
